import React from "react";
// import { useTranslation } from "react-i18next";
import { Select } from "antd";
import TagRecipient from "pages/admin/broadcast/tagRecipient";
// import classNames from "classnames";
// import { PATTERNS } from "constants/appConstant";
// import debounce from "lodash/debounce";
// import TagRecipient from "pages/admin/broadcast/tagRecipient";
// import { generateUniqueColor } from "utils";

// import styles from "./styles.module.scss";
// function DebounceSelect({
//   fetchOptions,
//   request,
//   debounceTimeout = 800,
//   setFetching,
//   fetching,
//   setOptions,
//   options,
//   config,
//   isRequeried,
//   // value,
//   ...props
// }) {
//   const fetchRef = useRef(0);
//   const { t } = useTranslation();

//   const debounceFetcher = useMemo(() => {
//     const loadOptions = value => {
//       fetchRef.current += 1;
//       const fetchId = fetchRef.current;
//       setOptions([]);
//       setFetching(true);
//       fetchOptions({
//         ...request,
//         searchKeyName: PATTERNS.BLANK_SPACES.test(value) ? value.trim() : "",
//       }).then(newOptions => {
//         if (fetchId !== fetchRef.current) {
//           // for fetch callback order
//           return;
//         }
//         setOptions(newOptions);
//         setFetching(false);
//       });
//     };
//     return debounce(loadOptions, debounceTimeout);
//   }, [fetchOptions, debounceTimeout]);
//   return (
//     <>
//       <Select
//         labelInValue
//         filterOption={false}
//         className={classNames({
//           [styles.wrapSelect]: false,
//           [styles.custom]: true,
//         })}
//         onSearch={debounceFetcher}
//         onPopupScroll={event =>
//           config?.handleScroll && config?.handleScroll(event)
//         }
//         // notFoundContent={fetching ? <Spin size="small" /> : null}
//         loading={fetching}
//         {...props}
//         tagRender={_tagProps => {
//           return <TagRecipient {..._tagProps} options={options} />;
//         }}
//         status={isRequeried ? "error" : ""}
//         style={{
//           width: "100%",
//           padding: "0",
//           textAlign: "start",
//           // height: 38,
//         }}
//       >
//         {options.map((option, index) => (
//           <Select.Option
//             key={index.toString()}
//             value={option.id}
//             disabled={option.disabled}
//             label={option.label}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 16,
//               }}
//             >
//               {typeof option.src === "string" && (
//                 <Avatar
//                   style={{
//                     backgroundColor: option.src
//                       ? "#fff"
//                       : generateUniqueColor(option.label),
//                     color: "#fff",
//                     textTransform: "uppercase",
//                     ...config?.styleIcon,
//                   }}
//                   src={option.src}
//                 >
//                   {option.src ? "" : option.label.charAt(0)}
//                 </Avatar>
//               )}
//               {typeof option.src === "function" && (
//                 <Avatar
//                   style={{
//                     color: "#fff",
//                     textTransform: "uppercase",
//                     ...config?.styleIcon,
//                   }}
//                   icon={option.src()}
//                 >
//                   {option.src ? "" : option.label.charAt(0)}
//                 </Avatar>
//               )}
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   justifyContent: "center",
//                   width: 650,
//                   textOverflow: "ellipsis",
//                   overflow: "hidden",
//                   whiteSpace: "nowrap",
//                 }}
//               >
//                 <Tooltip title={option.label}>
//                   <span style={{ fontWeight: 700 }}>{option.label}</span>
//                 </Tooltip>
//                 <span>{option.phone}</span>
//               </div>
//             </div>
//           </Select.Option>
//         ))}
//       </Select>
//       {isRequeried ? (
//         <div style={{ color: "red" }}>{t("validate.required")}</div>
//       ) : (
//         <></>
//       )}
//     </>
//   );
// }
const SelectSearchCustomer = _props => {
  const {
    // type,
    options,
    // value,
    noAllowClear,
    // // selectKeyValue,
    config,
    // placeholder,
    // // selectKeyLabel,
    // tagRender: TagRender,

    // onChange = () => {},
  } = _props;
  // const tagRender = props => {
  //   const { label, value, closable, onClose } = props;
  //   const onPreventMouseDown = event => {
  //     event.preventDefault();
  //     event.stopPropagation();
  //   };
  //   return (
  //     <Tag
  //       color={value}
  //       onMouseDown={onPreventMouseDown}
  //       closable={closable}
  //       onClose={onClose}
  //       style={{
  //         marginRight: 3,
  //       }}
  //     >
  //       {label}
  //     </Tag>
  //   );
  // };

  return (
    <Select
      mode="multiple"
      onSearch={event =>
        config?.handleSearchKey && config?.handleSearchKey(event)
      }
      onSelect={value => {
        console.log("value", value);
      }}
      allowClear={!noAllowClear}
      tagRender={props => {
        return <TagRecipient options={options} {...props} />;
      }}
    >
      {options.map((option, index) => (
        <Select.Option
          key={index.toString()}
          value={option.id}
          disabled={option.disabled}
          label={option.label}
        ></Select.Option>
      ))}
    </Select>
  );
};

export default SelectSearchCustomer;
